module.exports = __webpack_public_path__ + "static/projects-d9414c89339ce5eae832d0b4dd4dac4f.jpg";